import { UnitTokenClasses } from './UnitSettings';

export const unitTokenKeyMap = {
  className: undefined,
  layout: undefined,
  gap: undefined,
  gridArea: undefined,
  background: undefined,
  boxShadow: undefined,
  borderLight: undefined,
  borderDark: undefined,
  borderColor: undefined,
  borderRadius: undefined,
  position: undefined,
  positionRight: undefined,
  positionBottom: undefined,
  positionTop: undefined,
  flexDirection: undefined,
  flexGrow: undefined,
  flexShrink: undefined,
  flexWrap: undefined,
  flexBasis: undefined,

  overLay: undefined,
  colSpan: undefined,
  rowSpan: undefined,
  justifyContent: undefined,
  justifyItems: undefined,
  alignContent: undefined,
  alignItems: undefined,
  justifySelf: undefined,
  alignSelf: undefined,
  paddingLeft: undefined,
  paddingRight: undefined,
  paddingTop: undefined,
  paddingBottom: undefined,
  margin: undefined,
  marginLeft: undefined,
  marginRight: undefined,
  marginTop: undefined,
  marginBottom: undefined,
  height: undefined,
  heightMin: undefined,
  heightMax: undefined,
  width: undefined,
  widthMin: undefined,
  widthMax: undefined,
  zIndex: undefined,
} satisfies Record<keyof UnitTokenClasses, undefined>;

export const unitTokenKeys = new Set<keyof UnitTokenClasses>(
  Object.keys(unitTokenKeyMap) as Array<keyof UnitTokenClasses>,
);
